import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class GetBijbEventsErrorAction implements Action {
  public static readonly type = 'GetBijbEventsErrorAction';

  constructor(public error: BijbError) {
  }

  public type = GetBijbEventsErrorAction.type;
}
